<template>
  <div class="img-back" v-if="hasError">
  </div>
  <img v-bind="$attrs" @error="imgError" v-else/>
</template>

<script>
import picEmptyBig from '../assets/img/pic_empty_big.png'
export default {
  name: '',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    pic: {
      type: String,
      default: 'coverUrl'
    }
  },
  data () {
    return {
      picEmptyBig,
      hasError: false
    }
  },
  methods: {
    imgError () {
      this.hasError = true
    }
  }
}
</script>

<style lang="scss" scoped>
.img-wrap {
  display: contents;
}
.img-back {
  background-image: url(../assets/img/pic_empty_big.png);
  background-size: 100% 100%;
  background-position: center center;
  height: 100%;
  background-repeat: no-repeat;
}
</style>
